import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import useApp from 'app/context/useApp';

import { paper } from 'app/styles/core';
import { containerCenter } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...containerCenter(theme),
        padding: theme.spacing(3)
    },
    paper: {
        ...paper(theme),
        textAlign: 'center'
    },
    supportItem: {
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
    },
}));

export default function Support(props) {

    const classes = useStyles();

    const { app } = useApp();

    return (
        <div className={classes.container}>
            <Paper className={classes.paper} elevation={4}>
                <Typography variant="h4" component="h1" gutterBottom>
                    {app.club.name} Support
                </Typography>
                <Typography gutterBottom>
                    Our support team is ready to help. Use the information below to get in touch with us.
                </Typography>
                <div className={classes.supportItem}>
                    <Typography component="div" variant="subtitle2">
                        Support Email:
                    </Typography>
                    <Typography component="div" variant="subtitle1" color="textSecondary" gutterBottom>
                        <Link
                            href={"mailto:" + app.club.support_email}
                            target="_blank"
                            color="secondary"
                            >
                            {app.club.support_email}
                        </Link>
                    </Typography>
                </div>
                {(app.club.support_phone && app.club.support_phone != "") &&
                    <div className={classes.supportItem}>
                        <Typography component="div" variant="subtitle2">
                            Support Phone:
                        </Typography>
                        <Typography component="div" variant="subtitle1" color="textSecondary" gutterBottom>
                            <Link
                                href={"tel:" + app.club.support_phone}
                                target="_blank"
                                color="secondary"
                                >
                                {app.club.support_phone}
                            </Link>
                        </Typography>
                    </div>
                }
                <Typography>
                    We typically respond to all emails or voicemails within a few hours. We look forward to hearing from you.
                </Typography>
            </Paper>
        </div>
    );
}
